// src/components/AñadirPOI.tsx

import React, { useState, FormEvent } from 'react';
import { crearPOIEnSegundoPlano, obtenerEstadoCreacionPOI } from '../api/api'; 
// Ajusta la ruta de import según tu estructura

// Componente para añadir un nuevo POI y ver su proceso de creación de rutas
const AñadirPOI: React.FC = () => {
  // 1. Estado para los campos del formulario
  const [Name, setName] = useState<string>('');
  const [Type, setType] = useState<string>('Attraction');
  const [Latitude, setLatitude] = useState<number>(42.7629103);
  const [Longitude, setLongitude] = useState<number>(-3.0891696);
  const [description, setDescription] = useState<string>('');
  const [horario, setHorario] = useState<string>('');

  // 2. Estado para el proceso de creación
  const [loading, setLoading] = useState<boolean>(false); // Para mostrar spinner
  const [status, setStatus] = useState<string>('');       // waiting, active, completed, failed...
  const [message, setMessage] = useState<string>('');     // Mensaje para el usuario

  // Manejador del submit del formulario
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus('waiting');
    setMessage('Creando POI y encolando la generación de rutas...');

    try {
      // 1) Llamamos a la API para crear el nodo y encolar la tarea
      const { jobId } = await crearPOIEnSegundoPlano(
        // ID, // Elimina esta línea
        Name,
        Type,
        Latitude,
        Longitude,
        description,
        horario
      );
      console.log('Job ID recibido:', jobId);

      // 2) Empezamos a hacer polling para consultar su estado
      pollJobStatus(jobId);
    } catch (error) {
      console.error('Error creando POI:', error);
      setLoading(false);
      setStatus('failed');
      setMessage('Error creando el POI');
    }
  };

  // Función recursiva para hacer polling cada 2s
  const pollJobStatus = async (jobId: string) => {
    try {
      const currentStatus = await obtenerEstadoCreacionPOI(jobId);
      console.log('Estado del job:', currentStatus);

      setStatus(currentStatus);

      if (currentStatus === 'completed') {
        // Todo fue bien
        setLoading(false);
        setMessage('¡POI creado y rutas generadas con éxito!');
      } else if (currentStatus === 'failed') {
        // Hubo un fallo, se borra el nodo
        setLoading(false);
        setMessage('Error generando rutas. El nodo se ha eliminado.');
      } else if (currentStatus === 'not_found') {
        // Job no existe
        setLoading(false);
        setMessage('El job no se encontró.');
      } else {
        // waiting / active / delayed...
        setTimeout(() => pollJobStatus(jobId), 2000); // volver a comprobar en 2s
      }
    } catch (error) {
      console.error('Error consultando estado del job:', error);
      setLoading(false);
      setMessage('Error consultando estado del POI');
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: 20 }}>
      <h1>Añadir un nuevo POI</h1>

      <form onSubmit={handleSubmit}>
        {/* Elimina este bloque completo */}
        {/* 
        <div style={{ marginBottom: 10 }}>
          <label>ID: </label>
          <input
            type="number"
            value={ID}
            onChange={(e) => setID(Number(e.target.value))}
            required
          />
        </div>
        */}

        <div style={{ marginBottom: 10 }}>
          <label>Name: </label>
          <input
            type="text"
            value={Name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label>Type: </label>
          <select value={Type} onChange={(e) => setType(e.target.value)}>
            <option value="Attraction">Attraction</option>
            <option value="Restaurant">Restaurant</option>
            <option value="Museum">Museum</option>
            {/* Agrega más opciones si quieres */}
          </select>
        </div>

        <div style={{ marginBottom: 10 }}>
          <label>Latitude: </label>
          <input
            type="number"
            step="any"
            value={Latitude}
            onChange={(e) => setLatitude(Number(e.target.value))}
            required
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label>Longitude: </label>
          <input
            type="number"
            step="any"
            value={Longitude}
            onChange={(e) => setLongitude(Number(e.target.value))}
            required
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label>Description: </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label>Horario: </label>
          <input
            type="text"
            value={horario}
            onChange={(e) => setHorario(e.target.value)}
          />
        </div>

        <button type="submit">Crear POI</button>
      </form>

      {loading && (
        <div style={{ marginTop: 20 }}>
          {/* Un spinner simple con texto. Sustituye con tu librería de spinners preferida */}
          <p style={{ color: 'blue' }}>Cargando... ⏳</p>
        </div>
      )}

      {message && (
        <div style={{ marginTop: 20 }}>
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default AñadirPOI;
